import getPoolStore from "../../../../stores/auditor-store/pool-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const PoolForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        await getPoolStore().getPool();
      }}
      size="LARGE"
      type="GET"
      text="GET"
    />
  );
});
export default PoolForm;
